export type AnalyticsPlatform =
  | 'web'
  | 'revit_plugin'
  | 'rhino_plugin'
  | 'archicad_plugin';

export function getClientAnalyticsPlatform(): AnalyticsPlatform {
  if (typeof window === 'undefined') {
    return 'web';
  }

  const hostWindow = window as Window & {
    arkyvArchicad?: unknown;
    arkyvRhino?: unknown;
  };

  if (hostWindow.arkyvRhino) {
    return 'rhino_plugin';
  }

  if (hostWindow.arkyvArchicad) {
    return 'archicad_plugin';
  }

  return window.chrome?.webview ? 'revit_plugin' : 'web';
}
